import { render, staticRenderFns } from "./discussionmanage.vue?vue&type=template&id=55348a8c&scoped=true&"
import script from "./discussionmanage.vue?vue&type=script&lang=js&"
export * from "./discussionmanage.vue?vue&type=script&lang=js&"
import style0 from "./discussionmanage.vue?vue&type=style&index=0&id=55348a8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55348a8c",
  null
  
)

export default component.exports